import Link from "next/link";

import { useCalendarLink } from "@/components/hooks/useCalendarLink";
import SparkleButton from "@/components/magicui/sparkle-button";
import { cn } from "@/lib/utils";

const CalendarBookingLink = ({ className = "", bottomText = "Really, we build it for you up front" }: { className?: string; bottomText?: string | null }) => {
  const { calendarLink } = useCalendarLink();

  return (
    <Link
      href={calendarLink}
      target="_blank"
      rel="noopener noreferrer"
      className={cn("inline-block text-center", className)}
    >
      <SparkleButton>Get A Free Look at My Website</SparkleButton>
      {bottomText && <span className="-mt-6 text-sm text-ash-500 block">{bottomText}</span>}
    </Link>
  );
};

export default CalendarBookingLink;
